import { SEARCH_HEADER } from './constants';

export const SearchHeader = () => {
  return (
    <div className="flex items-center justify-between">
      <div className="text-2xl font-medium">{SEARCH_HEADER}</div>
    </div>
  );
};
